<template>
  <h1
    v-if="productTitles.subtitle && !isMasterPPUrl"
    class="mb-8 flex flex-col"
  >
    <span class="heading-1">{{ productTitles.default }}</span>
    <span class="body-2">{{ productTitles.subtitle }}</span>
  </h1>

  <h1 v-else class="heading-1 mb-8">
    {{ productTitles.default }}
  </h1>
</template>

<script setup lang="ts">
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import { useMasterPP } from '~/scopes/product/composables/useMasterPP/useMasterPP'

defineProps<{
  productTitles: GetProductResponse['titles']
}>()

const { isMasterPPUrl } = useMasterPP()
</script>
